import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
// import appReducers from './reducers';
// import { createLogger } from 'redux-logger';
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "./reducers";

export const history = createBrowserHistory();

// const logger = createLogger({
//   collapsed: true,
// });

export default function configureStore() {
	const store = createStore(
		createRootReducer(history), // root reducer with router state
		compose(
			applyMiddleware(
				routerMiddleware(history), // for dispatching history actions
				thunk
				// logger,
				// ... other middlewares ...
			)
		)
	);

	return store;
}
